/** Module registration — the one file that changes when a module is added. */
import { ordersWebModule } from '@daka/modules/orders/web';

import { webModules } from '@/host/module';

function registerModules(): void {
   webModules.register(ordersWebModule);
}

// Registered at import time so the shell can render navigation on first paint,
// without an effect and without a loading state for something statically known.
registerModules();
